@if (contactWindowOpened) {
  <div [@fadeInOnEnter] [@fadeOutOnLeave] class="contact-content">
    <div class="body">
      <div class="card">
        <div class="title">
          @if (!user) {
            <h2 class="greeting" translate>SUPPORT.FLOAT.GREETING</h2>
          }
          @if (user) {
            <h2 class="greeting" [translateParams]="{name: user.first_name}" translate>SUPPORT.FLOAT.GREETING_WITH_NAME</h2>
          }
          <h2 class="subheadline" translate>SUPPORT.FLOAT.SUBHEADLINE</h2>
        </div>
        <div>
          <span translate>SUPPORT.FLOAT.BODY.PRE</span>
          <a class="textlink" href="mailto:info@troodi.de">info&#64;troodi.de</a>
          <span translate>SUPPORT.FLOAT.BODY.POST</span>
        </div>
        <a class="mt-2" href="mailto:info@troodi.de" mat-raised-button color="primary">
          <span translate>SUPPORT.FLOAT.BUTTONS.CONTACT</span>
        </a>
      </div>
      @if (user) {
        <div class="card">
          <span translate>SUPPORT.FLOAT.OTHER</span>
          <button class="mt-2" mat-stroked-button color="primary" (click)="openOnboardingTourClicked()">
            <span translate>SUPPORT.FLOAT.BUTTONS.TOUR</span>
          </button>
          <a mat-stroked-button routerLink="/settings" (click)="toggleContactWindowOpened()" color="primary">
            <span translate>SUPPORT.FLOAT.BUTTONS.LANGUAGE</span>
          </a>
        </div>
      }
    </div>
  </div>
}
<button class="contact-button" mat-fab color="accent" (click)="toggleContactWindowOpened()">
  <mat-icon svgIcon="chat_v2"></mat-icon>
</button>
